/// <reference path="../app.js"/>

class PortfolioPage {
	static filterFeaturedProjects() {
		$(`.PortfolioPage .featured-projects .project:not(.hide)`).each((index, element) => {
			if (index > 2) $(element).addClass("hide");
		});
	}

	static init() {
		$(".PortfolioPage [data-filter-category]").on("click", function() {
			const category = $(this).data("filter-category");

			// $.get(category == "all" ? `/our-work/category/` : `/our-work/category/${category}`);

			if (category == "all") {
				$(".PortfolioPage [data-category]").removeClass("hide");
				$(".PortfolioPage [data-category].featured-all").addClass("hide");
				history.pushState(null, document.title, `${window.location.protocol}//${window.location.host}/our-work/`);
			}
			else {
                // $(`.PortfolioPage [data-category]`).addClass("hide").filter(`[data-category*=${category}]:not(.all-only.featured-${category}), [data-category=${category}].featured.not-all`).removeClass("hide");

                $(`.PortfolioPage [data-category]`).addClass("hide");	
                // Show Featured Projects in this Category
                $(`.PortfolioPage .featured[data-category=${category}]:not(.all-only)`).removeClass("hide");
                // Show Projects Tile Grid in this Category
                $('.PortfolioPage .tile').removeClass('hide-featured');
                $(`.PortfolioPage .tile[data-category*=${category}]:not(.featured-${category})`).removeClass("hide");

				history.pushState(null, document.title, `${window.location.protocol}//${window.location.host}/our-work/category/${category}`);
			}

			let doTransition = true;

			const parallaxTransition = () => {
				document.body.dispatchEvent(new Event("scroll", { bubbles: true }));
				document.body.dispatchEvent(new Event("fx-reflow", { bubbles: true }));
				if (doTransition) requestAnimationFrame(parallaxTransition);
			}

			parallaxTransition();
			PortfolioPage.filterFeaturedProjects();
			checkScroll();

			setTimeout(() => doTransition = false, 500);
		});

		this.filterFeaturedProjects();

		$(".PortfolioPage .go-up").on("click", () => window.scrollTo({
			left: 0,
			top: 0,
			behavior: "smooth"
		}));

		$(".PortfolioPage a[data-project]").on("click", function() {
			$("header").addClass("project-navigate");
		});

		$(".Project .photos .carousel").slick({
			centerMode: true,
			arrows: true,
			dots: true,
			autoplay: true,
			autoplaySpeed: 5000
		});

		$(".Project .category-transition").removeClass("category-transition");

		$(".Project").on("click", ".go-back", () => {
			$.get(`/our-work/color`).then(color => {
				$("#transition-frame").css("background-color", color).removeClass("slide-out").addClass("slide-in");
				$("header").addClass("use-menu-logo");

				setTimeout(() => location.href = $(".Project .go-back").data("link"), 500);
			}).catch(() => history.back());
		});

		$(`img[data-wistia-thumbnail]`).each((_index, element) => {
			$.getJSON(`http://fast.wistia.com/oembed?url=${encodeURI(`http://home.wistia.com/medias/${$(element).data("wistia-thumbnail")}`)}`).then(result => {
				element.setAttribute("src", result.thumbnail_url);
			});
		});

		$(".Project .styleguide .typography-container").each((_index, element) => {
			const container = $(element);
			let size = Infinity;

			container.find(".image").each((_index, /** @type {HTMLImageElement} */image) => {
				size = size > image.height ? image.height : size;
			}).css("height", `${size}px`).addClass("ready");
		});

		$(".Project .next-project [next-project]").on("click", function(event) {
			$("header").removeClass("small").removeClass("scroll-down");
			
			const project = $(".next-project .project");
			const container = $(".next-project");
			const { top } = project[0].getBoundingClientRect();

			container.css("height", `${container[0].getBoundingClientRect().height}px`);

			project.css("position", "fixed");
			project.css("--position", `${top - 90}px`);
			
			$(document.body).addClass("project-transition");
			const href = $(this).attr("next-project");

			setTimeout(() => location.href = href, 1000);

			event.preventDefault();

			return false;
		});

		$("img[async-src]").each((_index, element) => {
			let image = $(element);
			let src = image.attr("async-src");
			let asyncImage = element.cloneNode();

			asyncImage.removeAttribute("async-src");
			asyncImage.setAttribute("src", src);

			image.after(asyncImage);
			image.removeAttr("async-src");

			FX.registerParallax(asyncImage);
		});
	}
}
